import { cn } from "@/lib/utils";
import { useLanguage } from "@/contexts/LanguageContext";

interface ButtonSectionProps {
  title: string;
  description: string;
  active?: boolean;
  onClick?: () => void;
}

export default function ButtonSection({
  title,
  description,
  active,
  onClick,
}: ButtonSectionProps) {
  const { language } = useLanguage();

  return (
    <button
      className={cn(
        "text-slate-900 px-6 py-5 rounded-3xl w-full flex flex-col text-start cursor-pointer gap-1 hover:shadow-xl hover:shadow-slate-300/20 hover:bg-gradient-to-b hover:from-white hover:to-transparent",
        active &&
          "bg-gradient-to-b from-white to-transparent shadow-xl shadow-slate-300/20",
        language === "fr" && "w-[500px]"
      )}
      onClick={onClick}
    >
      <div className="font-medium">{title}</div>
      <div className="text-sm text-slate-700">{description}</div>
    </button>
  );
}
